"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MockedFooter() {
  /* eslint-disable */
  return _react2.default.createElement(
    "div",
    { className: "basepagelayout-footer" },
    _react2.default.createElement(
      "div",
      { className: "we_footer" },
      _react2.default.createElement(
        "div",
        { className: "ee_footerLinks" },
        _react2.default.createElement(
          "a",
          { className: "HideInTrx", href: "#" },
          "Actualit\xE9s"
        ),
        _react2.default.createElement(
          "a",
          { href: "#" },
          "Nous joindre"
        ),
        _react2.default.createElement(
          "a",
          { href: "#" },
          "FAQ"
        ),
        _react2.default.createElement(
          "a",
          { href: "#" },
          "Protection des renseignements personnels"
        ),
        _react2.default.createElement(
          "a",
          { href: "#" },
          "Conditions d'utilisation"
        ),
        _react2.default.createElement(
          "a",
          { className: "ee_languageSelector ShowInMobile HideInFull HideInTablet HideInTrx" },
          "English"
        )
      ),
      _react2.default.createElement(
        "div",
        { className: "legalNotice" },
        _react2.default.createElement("hr", null),
        _react2.default.createElement(
          "p",
          null,
          "iA Groupe financier est une marque de commerce et un autre nom sous lequel l\u2019Industrielle Alliance, Assurance et services financiers inc. exerce ses activit\xE9s."
        )
      )
    )
  );
  /* eslint-enable */
}

exports.default = MockedFooter;